'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _selectors = require('@marmalade/query/lib/selectors');
var _policy = require('./customer/selectors/policy');
exports.default = function (state, theme) {
  var policy = (0, _policy.guid)(state);
  if (policy) {
    return policy;
  }
  if (theme.guid) {
    return theme.guid;
  }
  var query = (0, _selectors.getQuery)(state, 'guid');
  if (query) {
    return query;
  }
  return undefined;
};